// src/components/molecules/SortSelector/SortSelector.jsx
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Menu, MenuItem } from '@mui/material';
import SortButton from '../../atoms/SortButton/SortButton';

// Definição das opções de ordenação dentro do próprio componente
export const ARTICLE_SORT_OPTIONS = [
  { value: 'date_desc', label: 'Publicação Recente' },
  { value: 'date_asc', label: 'Publicação Antiga' },
  { value: 'created_desc', label: 'Cadastro Recente' },
  { value: 'created_asc', label: 'Cadastro Antigo' },
  { value: 'valuation_desc', label: 'Maior Valoração' },
  { value: 'valuation_asc', label: 'Menor Valoração' },
  { value: 'tier_asc', label: 'Tier 1 Primeiro' },
  { value: 'tier_desc', label: 'Tier 3 Primeiro' },
  { value: 'title_az', label: 'Título A-Z' },
  { value: 'title_za', label: 'Título Z-A' },
  { value: 'source_az', label: 'Fonte A-Z' },
  { value: 'source_za', label: 'Fonte Z-A' }
];

/**
 * SortSelector - Componente molecular para seleção de ordenação
 * 
 * Este componente combina o SortButton com um menu dropdown para
 * seleção de opções de ordenação. Segue o princípio do Atomic Design
 * como uma "molécula".
 */
const SortSelector = ({
  value,
  onChange,
  options = ARTICLE_SORT_OPTIONS, // Usando as opções padrão definidas
  className = '',
  ...props
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (optionValue) => {
    onChange(optionValue);
    handleClose();
  };

  return (
    <>
      <SortButton
        onClick={handleClick}
        className={`sort-selector ${className}`}
        {...props}
      />

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {options.map((option) => (
          <MenuItem
            key={option.value}
            selected={value === option.value}
            onClick={() => handleSelect(option.value)}
            sx={value === option.value ? { color: 'primary.main', fontWeight: 600 } : {}}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

SortSelector.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ),
  className: PropTypes.string
};

// Não precisa mais definir defaultProps explicitamente já que já definimos o valor padrão no parâmetro

export default SortSelector;
